export enum DriversLicenseCategory {
  B = 'b',
  B1 = 'b1',
  BE = 'be',
  C = 'c',
  C1 = 'c1',
  C1E = 'c1e',
  CE = 'ce',
}
